import React, {Component} from "react";

export default class Promotions extends Component {

    renderPromotionItem(promotions) {
        return promotions.promoCategories.map((promoCategory, index) => {
            return (<li className='list-group-item' key={ promoCategory.type }>
                <div className='row pl-2'>
                    <span className="badge badge-danger fs-12">{ promoCategory.type }</span>
                    <span className='ml-2 fs-12'>{ promoCategory.title }</span>
                </div>
            </li>);
        });
    }

    render() {
        const { promotions, className } = this.props;
        if (!promotions || !promotions.promoCategories) {
           return <div></div> ;
        }
        return (
            <ul className={ className + ' ' + 'list-group' }>
                { this.renderPromotionItem(promotions) }
            </ul>
        )
    }
}